import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import Module from "utilities/global/sparta-module-utility/6.3.1/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.2.3/js/sparta-validation-framework";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.8/js/sparta-messaging-utility";
import ahCawCqController from "modules/login/ah-caw-cq-module/5.2.2/js/ah-caw-cq-controller";
import ahCawCqView from "modules/login/ah-caw-cq-module/5.2.2/js/ah-caw-cq-view";
import ahCawCqModel from "modules/login/ah-caw-cq-module/5.2.2/js/ah-caw-cq-model";
import spartaTemplates from "modules/login/ah-caw-cq-module/5.2.2/js/templates";
import "css!modules/login/ah-caw-cq-module/5.2.2/css/ah-caw-cq-module.scss.css";









export default class ahCawCqModuleJS extends Module {
  constructor(options) {
    super(options);
    this._debug('ahSecureSigninModule Instantiated with options:', options);
    this.apiEndPoints = {};




    this.endpoints = options.endpoints;
    const basePath = ahCawCommons.getBasePath(this.spaParams);
    this.apiEndPoints = ahCawCommons.getEndPoints(options.endpoints, basePath);
  }

  init(args = {}) {
    Object.assign(this.view, new ahCawCqView(this));
    Object.assign(this.model, new ahCawCqModel(this));
    Object.assign(this.controller, new ahCawCqController(this));

    this.view._initialize();
    this.model._initialize();
    this.controller._initialize();

  }
}
